import { useMutation } from '@tanstack/react-query';
import { api } from '../../../../services/api';

export function useVerifyImap(projectId: string) {
  return useMutation({
    mutationFn: (source: Record<string, any>) =>
      api.post(`/project/${projectId}/imap/credentials/verify`, { source }),
  });
}
